import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-form-validation-custom',
  templateUrl: './form-validation-custom.component.html',
  styleUrls: ['./form-validation-custom.component.css']
})
export class FormValidationCustomComponent implements OnInit {
  @ViewChild('f')
  private f: NgForm;

  wmodel: any = {};

  constructor() { }

  ngOnInit() {
  }

  register(f: NgForm) {
    console.log('Successful registration');
    console.log(f);
  }

  getTitle(): string {
    return "form validation custom";
  }
}



// WEBPACK FOOTER //
// ./src/app/test/form-validation-custom/form-validation-custom.component.ts